export const MESSAGING_DRAWER_WIDTH = '698px';
